<template>
  <layout-content>
    <filter-component />
    <stats-chart />
    <v-tabs
      class="mb-0"
      v-model="tab"
      align-with-title
    >
      <v-tabs-slider color="#394858" />
      <v-tab
        class="ml-0 px-5"
        active-class="tab-active"
        key="employees"
        name="employees"
        @click="$router.push( 'employees' )"
      >
        {{ $t(`monitoring.employees.title`)}}
      </v-tab>
      <v-tab
        class="ml-0 px-5"
        active-class="tab-active"
        key="groups"
        name="groups"
        @click="$router.push( 'groups' )"
      >
        {{ $t(`monitoring.groups.title`)}}
      </v-tab>
    </v-tabs>

    <component :is="`stats-${$route.params.type}`" />
    <stats-chart-call />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';
  import FilterComponent from '@monitoring/components/monitoring-table-filter';
  import StatsChart from '@monitoring/components/stats-general-chart-main'
  import StatsChartCall from '@monitoring/components/stats-general-chart-call'
  export default {
    components: {
      FilterComponent,
      StatsChart,
      StatsChartCall,
      'stats-employees': () => import('@monitoring/components/stats-employees'),
      'stats-groups': () => import('@monitoring/components/stats-groups')
    },

    watch: {
      '$route.params.type': {
        handler: function() {
          this.add_breadcrumbs({
            item: {
              title: `shared.breadcrumb.stats.${this.$route.params.type}`,
              route: {
                name: 'monitoring.stats.type',
                params: { type: this.$route.params.type }
              }
            }
          });
        },

        immediate: true
      }
    },

    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcrumbs: 'add_item' })
    }
  };
</script>

<style lang="scss" scoped>
  .v-tabs {
    position: relative;
    z-index: 9;
  }
</style>